import type React from 'react';

export interface SectionCardProps {
  title: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, className, children }) => (
  <div className={`bg-white rounded-[var(--dashboard-radius)!important] p-[var(--dashboard-padding)] ${className ?? ''}`}>
    <div className='flex items-center border-b pb-2 mb-4 relative -mx-[var(--dashboard-padding)] -my-[calc(var(--dashboard-padding)/2)]'>
      <span className="before:content-[''] before:block before:w-1 before:h-5 before:bg-primaryColor-normal before:rounded-sm before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 ml-4 font-semibold text-lg text-neutralColor-darkest pl-4">
        {title}
      </span>
    </div>
    {children}
  </div>
);

export default SectionCard;
// Usage: <SectionCard title="Title">Content</SectionCard>
